import { useRestoreTasks } from 'features/tasks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Undo } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { Task } from 'shared/types/task';

import { MenuGroups } from './types';

export type RestoreListProps = {
  tasks: Task[];
  onClose: () => void;
  registerItem?: (
    group: MenuGroups,
    index: number,
    element: HTMLButtonElement | null,
  ) => void;
  registerGroup?: MenuGroups;
};

export const RestoreList: React.FC<RestoreListProps> = ({
  tasks,
  onClose,
  registerItem,
  registerGroup,
}) => {
  const { t } = useTranslation();
  const restoreTasks = useRestoreTasks();

  const onRestore = async () => {
    await restoreTasks(tasks);
    onClose();
  };

  return (
    <PopupMenuList hasBottomBorder>
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={onRestore}
          start={<Icon icon={Undo} />}
          ref={(el) => registerGroup && registerItem?.(registerGroup, 0, el)}
        >
          {t('context-menus.task.labels.restore')}
        </PopupMenuButton>
      </PopupMenuListItem>
    </PopupMenuList>
  );
};
